import { AlertTriangle, Database, RefreshCw } from 'lucide-react'

export function LoadingState() {
  return (
    <div className="state-screen" role="status">
      <div className="state-icon"><Database size={24} /></div>
      <h1>Loading the live sheet</h1>
      <p>Reading Organizations and Opportunities without changing the source.</p>
      <div className="loading-line"><span /></div>
    </div>
  )
}

export function ErrorState({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="state-screen" role="alert">
      <div className="state-icon is-error"><AlertTriangle size={24} /></div>
      <h1>The Google Sheet could not be loaded</h1>
      <p>{message}</p>
      <button className="button button-primary" onClick={onRetry} type="button">
        <RefreshCw size={17} /> Try again
      </button>
    </div>
  )
}
